import { __assign } from "tslib";
import * as React from 'react';
import { StyledIconBase } from '@styled-icons/styled-icon';
export var Train = React.forwardRef(function (props, ref) {
  var attrs = {
    "fill": "currentColor",
    "xmlns": "http://www.w3.org/2000/svg"
  };
  return React.createElement(StyledIconBase, __assign({
    iconAttrs: attrs,
    iconVerticalAlign: "middle",
    iconViewBox: "0 0 24 24"
  }, props, {
    ref: ref
  }), React.createElement("path", {
    fill: "none",
    d: "M17.63 5a2.704 2.704 0 00-.253-.335c-.55-.617-1.021-.664-1.041-.666L7.625 4c-.001.001-.462.039-.989.653-.104.12-.174.234-.246.347h11.24zM18 8V7H6v3h12zM6 12v5h12v-5H6zm2.5 4a1.5 1.5 0 11.001-3.001A1.5 1.5 0 018.5 16zm7 0a1.5 1.5 0 11.001-3.001A1.5 1.5 0 0115.5 16z",
    key: "k0"
  }), React.createElement("circle", {
    cx: 8.5,
    cy: 14.5,
    r: 1.5,
    key: "k1"
  }), React.createElement("circle", {
    cx: 15.5,
    cy: 14.5,
    r: 1.5,
    key: "k2"
  }), React.createElement("path", {
    d: "M18.871 3.335C17.715 2.037 16.509 2 16.375 2H7.621c-.224 0-1.399.065-2.503 1.351C4.031 4.616 4 5.862 4 6v12a1 1 0 001 1h2l-2 3h2.317l.667-1h8l.677 1H19l-2-3h2a1 1 0 001-1V6c.001-.187-.032-1.434-1.129-2.665zM7.625 4l8.711-.001c.02.002.491.049 1.041.666.102.114.182.226.253.335H6.39c.072-.113.143-.227.246-.347.527-.614.988-.652.989-.653zM6 8V7h12v3H6V8zm12 9H6v-5h12v5z",
    key: "k3"
  }));
});
Train.displayName = 'Train';
export var TrainDimensions = {
  height: 24,
  width: 24
};